import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

// The back makes every activated planzone resource that isn't a subordinate yet report to the manager.
function createInteractor(repository: Repository): Interactor {
  return ({ manager }) =>
    present(
      repository
        .assignEveryoneToManager(manager)
        .then((subordinates) => ({ manager, subordinates }))
        .catch(() => Promise.reject({ manager })),
    );
}

export type { Interactor };

export { createInteractor };
